<template>
  <div class="editPage__video upLoadBox">
    <div class="title">落地效果视频</div>
      <ul class="videoBox">
        <li v-for="item in videoUrl" :key="item">
          <div class="editIconBox">
            <i class="el-icon-zoom-in" @click="openDialog(ImgPath,item)"></i>
            <i class="el-icon-delete" v-if="editLook != 2" @click="deleteVideoUrl(item)"></i>
          </div>
          <video width="100%" >
            <source :src="ImgPath + item" type="video/mp4" />
          </video>
        </li>
      </ul>
      <div class="img__con" v-if="editLook != 2">
        <el-upload
          class="avatar-uploader"
          :action="uploadImgUrl"
          :data="uploadImgData"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
          :on-progress="uploadVideoProcess"
          multiple
          :limit="9"
        >
        <div tabindex="0" class="el-upload el-upload--picture-card"><i class="el-icon-plus"></i><input type="file" name="projectionPointBitmap" class="el-upload__input"></div>
          <el-progress
            v-if="videoFlag == true"
            type="line"
            :percentage="videoUploadPercent"
            style="margin-top: 30px"
          ></el-progress>
        </el-upload>
        <p>
          说明: 视频格式为mp4格式，每个视频大小不超过300m
        </p>
      </div>
    
        <el-dialog :visible.sync="dialogVisible" append-to-body :before-close="closeVideo" key="video">
          <video width="100%" height="600px" controls="controls" ref="dialogVideo" >
              <source :src="dialogUrl" type="video/mp4" />
          </video>
        </el-dialog>
    
  </div>
</template>
<script>
export default {
  props:{
        formValue:{
            default:''
        },
      editLook:{
          default:0
      }
  },
   data() {
    return {
      videoUrl: [],
      // 视频上传
      uploadImgUrl: '',
      uploadImgData: { busiName: 32 },
      videoFlag: false,  // 进度条相关的
      videoUploadPercent: 0,  // 进度条相关的
      dialogVisible:false,
      dialogUrl:'',
    };
  },
  created(){
    this.uploadImgUrl = this.$http.getSignUrl('/api/files/upload', {
        type: 'video'
    })
    if(this.formValue){
      this.videoUrl = this.formValue.split(',')
      this.$emit('changeVideoData',this.videoUrl)
    }
  },
  methods: {
    // 删除视频
    deleteVideoUrl(item){
      this.videoUrl = this.videoUrl.filter((e)=>{
        return e != item
      })
      // 修改父级数据
      this.$emit('changeVideoData',this.videoUrl)
    },
    // 关闭视频
    closeVideo(){
      this.$refs.dialogVideo.pause()
      this.dialogVisible =  false;
    },
    // 播放视频
    openDialog(ImgPath,savePath){
      this.dialogUrl = ImgPath + savePath;
      this.dialogVisible =  true;
    },
    // 上传成功的函数
    handleAvatarSuccess(res, file) {
      if(res.success){
        this.videoUrl.push(res.data.savePath)
        this.videoFlag = false;
        this.$emit('changeVideoData',this.videoUrl)
      }
    },
    beforeAvatarUpload(file) {
      if(this.videoUrl.length >= 9){
        this.$message.error("最多只能上传9个视频!");
        return;
      }
      const isMp4 = file.type === "video/mp4";
      // 限制文件最大不能超过 300M
      const isLt2M = file.size / 1024 / 1024 < 300;

      if (!isMp4) {
        this.$message.error("视频只能是mp4格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 300MB!");
      }
      return isMp4 && isLt2M;
    },

    //进度条
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true;
      this.videoUploadPercent = parseInt(file.percentage);
    },
 }
};
</script>
<style lang="scss" scoped>
.editPage__video {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 16px;
    color: #8c939d;
    width: 350px;
    height: 30px;
    line-height: 30px;
    text-align: center;
  }
  .avatar {
    width: 350px;
    height: auto;
    display: block;
  }
  .title {
    // font-size: 18px;
    // margin-bottom: 20px;
  }
  .img__con {
    .el-button {
      width: 100%;
      margin: 10px 0 20px 0;
    }
  }
  .videoBox{
    display: flex;
    flex: wrap;
    li{
      margin: 0 8px 8px 0;
      position: relative;
      width: 60px;
      height: 60px;
      cursor: pointer;
      .editIconBox{
        width: 100%;
        height: 100%;    background: rgba(0,0,0,.5);
        position: absolute;
        top: 0;
        left: 0; 
        opacity: 0;
        z-index: 1;  
         display: flex;
        justify-content: space-around;
        align-items: center;    
        transition: opacity .3s;
        border-radius: 5px;
        i{
          font-size: 20px;
          color: #fff;
        }
      }
    }
    li:hover .editIconBox{
      opacity: 1;
    }
  }
  video{
    width: 60px;
    height: 60px;
  }
}
</style>